import React from 'react'
import {
    Card, CardBody, CardTitle, 
} from 'reactstrap';

let InfoCard = (props) => {
    return (
        <div>
            <Card>
                <CardBody>
                    <CardTitle tag="h5"><div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center'}}>{props.title}{props.button ?? null}</div></CardTitle>
                </CardBody>
                <CardBody>
                    {props.children}
                </CardBody>
            </Card>
        </div>
    );
}
export default InfoCard;